export enum ResourceType {
    Function = 'function',
    Execution = 'execution',
    Message = 'message',
    Backup = 'backup',
}